module.exports = __webpack_public_path__ + "img/info.2d7b1b2d.svg";